import React from "react";
import Modal from "react-bootstrap/Modal";
import BailingImage from "../../../../../../assets/images/bailing.png";
import { toast } from "react-toastify";

const SuccessModal = ({
  showSuccessModal,
  handleCloseSuccessModal,
  code,
  ProcessedEvacuation,
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    toast.success("Code copied !", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      pauseOnHover: true,
      progress: undefined,
      theme: "light",
    });
  };

  const formatted = (ProcessedEvacuation?.waste_categories || [])
    .map(
      (cat) =>
        cat
          .split("_") // split by underscore
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize each word
          .join(" ") // join words back
    )
    .join(", ");

  return (
    <div>
      <Modal
        show={showSuccessModal}
        onHide={() => {
          handleCloseSuccessModal();
          window.location.reload();
          //   showSuccessModal();
        }}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div>
            <div className="text-center mt-3 mb-5">
              <div className="successImg mb-4">
                <img src={BailingImage} alt="success img" />
              </div>
              <div>
                <h5>Waste Evacuation Captured Successfully</h5>
                <p style={{ fontSize: "14px" }}>
                  <span style={{ color: "#404040" }}>Driver Name:&nbsp;</span>
                  {ProcessedEvacuation?.driver_name?.toUpperCase()}
                </p>
                <p style={{ fontSize: "14px", marginTop: "10px" }}>
                  <span style={{ color: "#404040" }}>
                    Vehicle Plate No:&nbsp;
                  </span>
                  {ProcessedEvacuation?.vehicle_plate_no?.toUpperCase()}
                </p>
                <p style={{ fontSize: "14px", marginTop: "10px" }}>
                  <span style={{ color: "#404040" }}>Categories:&nbsp;</span>

                  {formatted}
                </p>
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                className="text-center"
              >
                <button
                  style={{ fontSize: "13px" }}
                  type="button"
                  className="btn loginBtn btn-sm btn-block w-50"
                  onClick={() => {
                    handleCopy();
                  }}
                >
                  Copy Code - {ProcessedEvacuation?.code}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SuccessModal;
